export default {
    DefaultPage: '/home',

    homeData: '/home',
    // Auth
    auth: {
        login: '/admin/admin/signIn',
        studentLogin: '/student/student/signIn',
        InstructorLogin: '/instructor/instructor/signIn',
        studentSignUp: '/user/student/register',

        logout: '/auth/logout',
        fetchUser: '/auth/me',
        sendResetLinkEmail: 'auth/password/forgot',
        reset: 'auth/password/reset'
    },

    // Media Library
    mediaUpload: '/media/upload',
    media: '/media/',
    mediaLibrary: '/media/library',
    mediaByIDs: '/media/ids',

    // Languages
    lang: '/lang',
    activeLangs: '/active-langs',

    // Categories
    category: '/categories',
    categoryFilter: '/category-filter',

    // Services
    service: '/services',
    serviceSearch: '/service/search',

    // Features
    feature: '/features',
    featureSearch: '/feature/search',

    // Clients
    provider: '/providers',
    pages: '/pages',

    // Contact
    contact: '/contact',

    // statuses
    statuses: '/statuses',

    // Installments
    installment: '/installments',
    partial: '/partials',

    // Notes
    note: '/notes',

    // Export
    export: {
        installment: '/export/installments',
        client: '/export/clients'
    },

    // Roles & Permissions
    roles: '/roles',
    permissions: '/permissions',

    // Admins
    allAdmins: '/admin/admin/viewAll',
    newAdmin: '/admin/admin/add',
    editAdmin: '/admin/admin/edit',
    fetchAdmin: '/admin/admin/viewOne',
    deleteAdmin: '/admin/admin/delete',

    // Students
    allStudents: '/admin/student/viewAll?page_number=1',
    newStudent: '/admin/student/add',
    editStudent: '/admin/student/edit',
    fetchStudent: '/admin/student/viewOne',
    deleteStudent: '/admin/student/delete',

    viewStudentCourses: '/admin/student/viewStudentCourses',
    viewStudentCurrentCourses: '/admin/student/viewCurrentStudentCourses',
    addStudentCourse: '/admin/student/addStudentCourse',
    deleteStudentCourse: '/admin/student/deleteStudentCourse',


    // Instructors
    allInstructors: '/admin/instructor/viewAll?page_number=1&page_size=999',
    InstructorCourses: '/admin/instructor/viewInstructorCourses?page_number=1&page_size=999',
    newInstructor: '/admin/instructor/add',
    editInstructor: '/admin/instructor/edit',
    fetchInstructor: '/admin/instructor/viewOne',
    deleteInstructor: '/admin/instructor/delete',
    addInstructorCourse: '/admin/instructor/addInstructorCourse',
    deleteInstructorCourse: '/admin/instructor/deleteInstructorCourse',


    // Programs
    Programs: {
        all: '/admin/program/viewAll?page_number=1&page_size=999',
        new: '/admin/program/add',
        edit: '/admin/program/edit',
        one: '/admin/program/viewOne',
        delete: '/admin/program/delete',
    },

    // Semesters
    Semesters: {
        all: '/admin/semester/viewAll?page_number=1&page_size=999',
        new: '/admin/semester/add',
        open: '/admin/semester/open',
        close: '/admin/semester/close',
        edit: '/admin/semester/edit',
        one: '/admin/semester/viewOne',
        delete: '/admin/semester/delete',
    },

    // Charging Codes
    allChargings: '/admin/chargingCode/viewAll?page_number=1&page_size=999',
    newCharging: '/admin/chargingCode/add',
    editCharging: '/admin/chargingCode/edit',
    fetchCharging: '/admin/chargingCode/viewOne',
    deleteCharging: '/admin/chargingCode/delete',

    // Faculties
    allFaculties: '/admin/faculty/viewAll?page_number=1&page_size=999',
    newFaculty: '/admin/faculty/add',
    editFaculty: '/admin/faculty/edit',
    fetchFaculty: '/admin/faculty/viewOne',
    deleteFaculty: '/admin/faculty/delete',

    //  Courses
    allCourses: '/admin/course/viewAll?page_number=1&page_size=999',
    courseStudents: '/admin/course/viewCourseStudents',
    newCourse: '/admin/course/add',
    editCourse: '/admin/course/edit',
    fetchCourse: '/admin/course/viewOne',
    approveCourseGrades: '/admin/course/approveCourseGrades',
    disapproveCourseGrades: '/admin/course/disApproveCourseGrades',
    deleteCourse: '/admin/course/delete',
    updateCourseGrades: '/admin/course/updateCourseGrades',

    //  Lectures
    allLectures: '/admin/lecture/viewAll?page_number=1&page_size=999',
    newLecture: '/admin/lecture/add',
    editLecture: '/admin/lecture/edit',
    fetchLecture: '/admin/lecture/viewOne',
    deleteLecture: '/admin/lecture/delete',

    // Request Access
    getRequests: '/admin/accessRequest/viewAll?page_number=1&page_size=2500',
    deleteRequest: '/admin/accessRequest/delete',
    approveRequest: '/admin/accessRequest/approve',


    student: {
        user: {
            edit: '/user/student/edit',
        },
        charge: 'user/chargingCode/charge',
        course:{
            buy: 'user/course/buy',
            view: '/user/course/viewOne',
            all: '/user/course/viewAll?page_number=1&page_size=999',
            student: 'user/course/viewByStudentId?page_number=1&page_size=999'
        },
        lecture:{
            buy: 'user/lecture/buy',
            view: '/user/lecture/viewOne',
        }
    },


    // Instructor API
    instructor: {
        courses: {
            current: '/instructor/course/viewCurrentInstructorCourses?page_number=1&page_size=999',
            all: '/instructor/course/viewAllInstructorCourses?page_number=1&page_size=999',
            students: '/instructor/course/viewCourseStudents?page_number=1&page_size=999',
            updateGrades: '/instructor/course/updateCourseGrades'
        }
    },

    // Student API
    student: {
        courses: {
            current: '/student/course/viewCurrentStudentCourses?page_number=1&page_size=999',
            all: '/student/course/viewAllStudentCourses?page_number=1&page_size=999',
        }
    },

    users: '/users',
    editProfile: '/edit-profile',



}
